import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';

import { openExternalUrl } from '@/adapters/browser/openExternalUrl';
import { SettingsNavigationItem } from '@/components/molecules/list';
import { PRIVACY_POLICY_URL } from '@/constants/externalUrls';
import { useTranslation } from '@/i18n';
import { spacing, unisonColors, useAppTheme } from '@/theme';

export const SettingsAppInfoSection = () => {
  const { t } = useTranslation();
  const { colors } = useAppTheme();

  const handlePrivacyPolicyPress = () => {
    void openExternalUrl(PRIVACY_POLICY_URL);
  };

  return (
    <View testID="settings-app-info-section">
      <Text style={[styles.sectionTitle, { color: colors.textNdPrimary }]}>
        {t('settings.appInfo.title')}
      </Text>
      <View style={styles.card} testID="settings-app-info-card">
        <SettingsNavigationItem
          opensExternally
          testID="settings-menu-item-privacyPolicy"
          title={t('settings.appInfo.privacyPolicy')}
          onPress={handlePrivacyPolicyPress}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  sectionTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    marginTop: spacing[2],
    marginBottom: spacing[2],
  },
  card: {
    backgroundColor: unisonColors.white,
    borderRadius: 8,
  },
});
